import { useQueryClient } from "@tanstack/react-query";

import { profilesKeys } from "./query_keys";

export const useProfilesInvalidate = () => {
  const cache = useQueryClient();
  return {
    invalidate: () => cache.invalidateQueries({ queryKey: profilesKeys.all() })
  };
};
